import axios from '@/allotment/axios'

export default {
  delete: ids => axios.post('/device/manage/delete', { ids }), //删除设备管理
  page: data => axios.post('/device/manage/page', data), //获取设备管理分页
  count: data => axios.post('/device/manage/count', data), //获取统计
  download: () => axios.post('/device/manage/download', {}, { notbody: true, responseType: 'blob', timeout: 10 * 60000 }), //下载
  imports: file => axios.post('/device/manage/imports', { file }, { headers: { 'Content-Type': 'multipart/form-data' } }) //导入
}
